import React from 'react';

// Local to the mailer screens: StatusBadge has no amber or rose tone and its defaults stay as they are.
const tones = { ok: 'bg-ds-green-lt text-ds-green-dk', warn: 'bg-ds-amber-lt text-ds-amber-dk', risk: 'bg-ds-rose-lt text-ds-rose-dk', neutral: 'bg-gray-200 text-gray-700', brand: 'bg-ds-brand-lt text-ds-brand-dk', info: 'bg-ds-blue-lt text-ds-blue-dk' };

/** Status pill: the dot and the label say it, so colour is never the only signal. */
export default function MailerBadge({ tone = 'neutral', children }) {
  return <span className={'inline-flex items-center gap-[6px] whitespace-nowrap rounded-ds-pill px-[10px] py-[3px] text-[10px] font-semibold uppercase tracking-[.06em] ' + tones[tone]}><span aria-hidden="true" className="h-[6px] w-[6px] rounded-full bg-current" />{children}</span>;
}
